// Application version
export const APP_VERSION = "0.2.0";

// Function to log version information
export const logVersion = () => {
  const buildDate = new Date().toISOString();
  console.log(`🚀 Coplaner v${APP_VERSION}`);
  console.log(`🌐 Environment: ${import.meta.env.MODE}`);
}; 